import { UserRole } from '../types/user';

/**
 * HA-37 / HIPAA: Practice Admins cannot communicate directly with clients;
 * the backend enforces this via `[ExcludeRoles(Role.PracticeAdmin)]` on
 * `MessageController`. The UI hides direct-messaging affordances (the
 * nav item in `AuthenticatedLayout`, the per-client Chat buttons in
 * Client Management, etc.) for any role the backend would 403, so the
 * user is never offered a dead-end click.
 *
 * Allowed: Practitioner, Client. Excluded: PracticeAdmin (HA-37) and
 * SystemAdmin (preserved from the prior inline policy in
 * `AuthenticatedLayout.tsx`; broaden only with an explicit HA-37 revisit).
 */
export const canAccessDirectMessaging = (role: UserRole | undefined): boolean =>
  role === UserRole.Practitioner || role === UserRole.Client;
